import {
  deleteAreaOfActivityService,
  getAreaOfActivityByIdService,
  getAreasOfActivityListService,
  getAreaOfActivityMetaService,
  patchAreaOfActivityService,
  postAreaOfActivityService,
} from '_/services/areaOfActivity'
import { defineAction } from '_/utils/redux'

export const GET_AREA_OF_ACTIVITY_LIST = defineAction('GET_AREAS_OF_ACTIVITY_LIST')
export const GET_AREA_OF_ACTIVITY_META = defineAction('GET_AREA_OF_ACTIVITY_META')
export const GET_AREA_OF_ACTIVITY_BY_ID = defineAction('GET_AREA_OF_ACTIVITY_BY_ID')
export const POST_AREA_OF_ACTIVITY = defineAction('POST_AREA_OF_ACTIVITY')
export const PATCH_AREA_OF_ACTIVITY = defineAction('PATCH_AREA_OF_ACTIVITY')
export const DELETE_AREA_OF_ACTIVITY = defineAction('DELETE_AREA_OF_ACTIVITY')

export const getAreaOfActivityList = () => async (dispatch, getState) => {
  const data = await getAreasOfActivityListService(getState().user.authToken)

  dispatch({
    type: GET_AREA_OF_ACTIVITY_LIST.ACTION,
    payload: async () => data,
  })

  return data
}

export const getAreasOfActivityMeta = () => async (dispatch, getState) => {
  const data = await getAreaOfActivityMetaService(getState().user.authToken)
  dispatch({
    type: GET_AREA_OF_ACTIVITY_META.ACTION,
    payload: async () => data,
  })
  return data
}

export const getAreaOfActivityById = id => async (dispatch, getState) => {
  const data = await getAreaOfActivityByIdService(getState().user.authToken, id)

  dispatch({
    type: GET_AREA_OF_ACTIVITY_BY_ID.ACTION,
    payload: async () => data,
  })

  return data
}

export const postAreaOfActivity = payload => async (dispatch, getState) => {
  const data = await postAreaOfActivityService(getState().user.authToken, payload)

  dispatch({
    type: POST_AREA_OF_ACTIVITY.ACTION,
    payload: async () => data,
  })

  return data
}

export const patchAreaOfActivity = (id, payload) => async (dispatch, getState) => {
  const data = await patchAreaOfActivityService(getState().user.authToken, id, payload)

  dispatch({
    type: PATCH_AREA_OF_ACTIVITY.ACTION,
    payload: async () => data,
  })

  return data
}

export const deleteAreaOfActivity = id => async (dispatch, getState) => {
  const data = await deleteAreaOfActivityService(getState().user.authToken, id)

  dispatch({
    type: DELETE_AREA_OF_ACTIVITY.ACTION,
    payload: async () => data,
  })

  return data
}
